module.exports = __webpack_public_path__ + "img/head.e90d9b33.png";